/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Notifications_Title1Inputs */

const id_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan Notifikasi`)
};

const ms_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapan Pemberitahuan`)
};

const da_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikationsindstillinger`)
};

const de_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungseinstellungen`)
};

const en_us2_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Settings`)
};

const es_es2_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de notificaciones`)
};

const es_mx2_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de notificaciones`)
};

const fil_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Setting ng Notipikasyon`)
};

const fr_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de notification`)
};

const it_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni notifiche`)
};

const hu_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesítési beállítások`)
};

const nl_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen instellingen`)
};

const no_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varslingsinnstillinger`)
};

const pl_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienia powiadomień`)
};

const pt_br2_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de notificação`)
};

const pt_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de notificações`)
};

const ro_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setări notificări`)
};

const fi_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitusasetukset`)
};

const sv_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notisinställningar`)
};

const vi_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cài đặt thông báo`)
};

const tr_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim Ayarları`)
};

const cs_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavení oznámení`)
};

const bg_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки за известия`)
};

const ru_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки уведомлений`)
};

const uk_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Налаштування сповіщень`)
};

const ar_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعدادات الإشعارات`)
};

const hi_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचना सेटिंग्स`)
};

const th_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตั้งค่าการแจ้งเตือน`)
};

const ja_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知設定`)
};

const zh_cn2_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知设置`)
};

const zh_hant1_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知設定`)
};

const ko_offerdetail_notifications_title1 = /** @type {(inputs: Offerdetail_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림 설정`)
};

/**
* | output |
* | --- |
* | "Notification Settings" |
*
* @param {Offerdetail_Notifications_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_notifications_title1 = /** @type {((inputs?: Offerdetail_Notifications_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Notifications_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_notifications_title1(inputs)
	if (locale === "ms") return ms_offerdetail_notifications_title1(inputs)
	if (locale === "da") return da_offerdetail_notifications_title1(inputs)
	if (locale === "de") return de_offerdetail_notifications_title1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_notifications_title1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_notifications_title1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_notifications_title1(inputs)
	if (locale === "fil") return fil_offerdetail_notifications_title1(inputs)
	if (locale === "fr") return fr_offerdetail_notifications_title1(inputs)
	if (locale === "it") return it_offerdetail_notifications_title1(inputs)
	if (locale === "hu") return hu_offerdetail_notifications_title1(inputs)
	if (locale === "nl") return nl_offerdetail_notifications_title1(inputs)
	if (locale === "no") return no_offerdetail_notifications_title1(inputs)
	if (locale === "pl") return pl_offerdetail_notifications_title1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_notifications_title1(inputs)
	if (locale === "pt") return pt_offerdetail_notifications_title1(inputs)
	if (locale === "ro") return ro_offerdetail_notifications_title1(inputs)
	if (locale === "fi") return fi_offerdetail_notifications_title1(inputs)
	if (locale === "sv") return sv_offerdetail_notifications_title1(inputs)
	if (locale === "vi") return vi_offerdetail_notifications_title1(inputs)
	if (locale === "tr") return tr_offerdetail_notifications_title1(inputs)
	if (locale === "cs") return cs_offerdetail_notifications_title1(inputs)
	if (locale === "bg") return bg_offerdetail_notifications_title1(inputs)
	if (locale === "ru") return ru_offerdetail_notifications_title1(inputs)
	if (locale === "uk") return uk_offerdetail_notifications_title1(inputs)
	if (locale === "ar") return ar_offerdetail_notifications_title1(inputs)
	if (locale === "hi") return hi_offerdetail_notifications_title1(inputs)
	if (locale === "th") return th_offerdetail_notifications_title1(inputs)
	if (locale === "ja") return ja_offerdetail_notifications_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_notifications_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_notifications_title1(inputs)
	return ko_offerdetail_notifications_title1(inputs)
});
export { offerdetail_notifications_title1 as "offerDetail.notifications.title" }